import { useLocation } from 'react-router-dom';

const normalizeWebBoosterType = (
  s: string | null,
): 'normal' | 'bible' | undefined =>
  s === 'normal' || s === 'bible' ? s : undefined;

const normalizeSource = (
  s: string | null,
): 'gdn' | 'gsearch' | 'facebook' | undefined =>
  s === 'gdn' || s === 'gsearch' || s === 'facebook' ? s : undefined;

const useRegisterQuery = () => {
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const webBoosterType = normalizeWebBoosterType(query.get('booster'));
  const source = normalizeSource(query.get('source'));

  let newQuery = '';
  if (webBoosterType) {
    newQuery += (newQuery ? '&' : '?') + 'booster=' + webBoosterType;
  }
  if (source) {
    newQuery += (newQuery ? '&' : '?') + 'source=' + source;
  }

  return {
    webBoosterType,
    source,
    query: newQuery,
  };
};

export default useRegisterQuery;
